import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../theme'
import isLink from '../../../theme/styles/isLink'

const Label = styled(Flex.withComponent('span') as any)<ILabel>`
  width: 100%;
  outline: none;

  height: ${({ size }) => (size ? 60 * size : 60)}px;
  line-height: ${({ size }) => (size ? 60 * size : 60)}px;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;

  ${isLink};

  color: #3e3e3e;

  padding-left: ${({ size }) => (size ? 6 * size : 6)}px;

  ${is('primary')`
  	padding-left: ${({ size }) => (size ? 10 * size : 10)}px
  `}

  &.primary {
    padding-left: 0em;
  }

  & > span {
    padding-left: 0px;
  }
`

export default Label

export interface ILabel {
  primary?: boolean
  size?: number
}
